var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInLoginPage)?_c('login-form',{attrs:{"id":0},on:{"toggleForm":_vm.toggleForm,"login":function($event){return _vm.login()}}}):_c('sign-up-form',{on:{"backToLogin":_vm.backToLogin,"toggleForm":_vm.toggleForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }